import memoize from 'memoize-one';

export function getFixedWidthStyle(fixedWidth) {
	return fixedWidth + 'px';
}

export function getScrollableLeftStyle(fixedWidth) {
	return fixedWidth + 'px';
}

export function getScrollableWidthStyle(fixedWidth) {
	return 'calc( 100% - ' + fixedWidth + 'px )';
}

export function getFixedHeaderStyle(fixedWidth, headerHeight) {
	return {
		width: getFixedWidthStyle(fixedWidth),
		height: headerHeight + 'px'
	};
}

export function getScrollableHeaderStyle(fixedWidth, headerHeight) {
	return {
		left: getScrollableLeftStyle(fixedWidth),
		width: getScrollableWidthStyle(fixedWidth),
		height: headerHeight + 'px'
	};
}

export function getFixedBodyStyle(fixedWidth, headerHeight) {
	return {
		top: headerHeight + 'px',
		width: fixedWidth + 'px',
		height: 'calc( 100% - ' + headerHeight + 'px )'
	};
}

export function getScrollableBodyStyle(fixedWidth, headerHeight) {
	return {
		left: fixedWidth + 'px',
		top: headerHeight + 'px',
		width: 'calc( 100% - ' + fixedWidth + 'px )',
		height: 'calc( 100% - ' + headerHeight + 'px )'
	};
}

export const DEFAULT_COLUMN_WIDTH = 120;

export const getColumnWidth = function(columnWidths, columnIndex) {
	if (columnWidths) {
		const res = columnWidths.get(columnIndex);
		if (typeof res === 'number') {
			return res;
		}
	}
	return DEFAULT_COLUMN_WIDTH;
}

export function getRowCheckBoxWidth() {
	return 24;
}

export const getFixedWidth = memoize((columnWidths, fixedColumns, withCheckBox) => {
	let res = 0;
	for (let i = 0; i < fixedColumns; i++) {
		res += getColumnWidth(columnWidths, i);
	}
	return res > 0 ? res + 1 + (withCheckBox ? getRowCheckBoxWidth() : 0) : 0;
});
